import React from 'react'
import Banner from './components/banner'
import OfferImmigrate from './components/offerImmigrate'
import About from './components/about'
import Services from './components/services'
// import BlogSection from './components/blogs'
import Contact from './components/contact'
import Meta from './components/Meta'


const Home = () => {
    return (
        <div>
            <Banner />
            <OfferImmigrate />
            <Meta
                title="Home | Trillium Sourcing Corporation"
                description="Welcome to Trillium Sourcing Corporation, your trusted partner for defence procurement and global sourcing solutions."
                keywords="defence procurement, global sourcing, OEM partners, defence sourcing, defence contracting"
            />
            <About />
            <Services />
            {/* <BlogSection /> */}
            <Contact />
            {/* <Footer /> */}
        </div>
    )
}

export default Home